import { useState } from 'react';
import { useTrip } from '@trip-planner-monorepo/shared';
import './SearchBar.css';
import { FiSearch, FiSettings } from 'react-icons/fi';

const SearchBar = ({ onOpenSettings }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const { searchTrip } = useTrip();

  const handleSearch = (e) => {
    e.preventDefault();
    searchTrip(searchTerm);
  };

  return (
    <form className="search-container" onSubmit={handleSearch}>
      <input
        type="text"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        placeholder="Search..."
        className="header-search-input"
      />
      <button type="submit" className="icon-button" title="Search" aria-label="Search">
        <FiSearch />
      </button>
      <button
        type="button"
        className="icon-button"
        onClick={onOpenSettings}
        title="Settings"
        aria-label="Settings"
        data-testid="settings-gear"
      >
        <FiSettings />
      </button>
    </form>
  );
};

export default SearchBar;
